/**
 * FAC Main Contact Section
 * スムーススクロールナビゲーション
 */

class FacMainContact {
  constructor(container) {
    this.container = container;
    this.navLinks = this.container.querySelectorAll('.fac-contact-navigation__link');
    this.contentBlocks = this.container.querySelectorAll('.page-contact__column');

    this.init();
  }

  init() {
    // スクロールイベントでナビゲーションをハイライト
    this.initScrollSpy();

    // ナビゲーションリンクのクリックイベント
    this.initNavigation();
  }

  initScrollSpy() {
    const options = {
      root: null,
      rootMargin: '-50% 0px -50% 0px',
      threshold: 0,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const id = entry.target.id;
          this.setActiveNavLink(id);
        }
      });
    }, options);

    this.contentBlocks.forEach((block) => {
      if (block.id) {
        observer.observe(block);
      }
    });
  }

  setActiveNavLink(targetId) {
    this.navLinks.forEach((link) => {
      const href = link.getAttribute('href');
      if (href === `#${targetId}`) {
        link.classList.add('is-active');
      } else {
        link.classList.remove('is-active');
      }
    });
  }

  initNavigation() {
    this.navLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('href').substring(1);
        const targetBlock = document.getElementById(targetId);

        if (targetBlock) {
          // getBoundingClientRect()を使用してビューポートからの正確な位置を取得
          const rect = targetBlock.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const offsetTop = rect.top + scrollTop - 100; // ヘッダー分のオフセット

          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth',
          });
        }
      });
    });
  }
}

// DOMが読み込まれたら初期化
document.addEventListener('DOMContentLoaded', () => {
  const contactContainers = document.querySelectorAll('.page-contact');
  contactContainers.forEach((container) => {
    new FacMainContact(container);
  });
});
